module.exports = __webpack_public_path__ + "img/banner-02.61916bd1.jpg";